var map = {
	"./AC.svg": 18750,
	"./AD.svg": 44033,
	"./AE.svg": 31792,
	"./AF.svg": 76931,
	"./AG.svg": 38994,
	"./AI.svg": 36852,
	"./AL.svg": 96473,
	"./AM.svg": 88552,
	"./AO.svg": 52074,
	"./AQ.svg": 67596,
	"./AR.svg": 39295,
	"./AS.svg": 18190,
	"./AT.svg": 43537,
	"./AU.svg": 80736,
	"./AW.svg": 88994,
	"./AX.svg": 67813,
	"./AZ.svg": 56215,
	"./BA.svg": 32085,
	"./BB.svg": 43862,
	"./BD.svg": 34856,
	"./BE.svg": 249,
	"./BF.svg": 8874,
	"./BG.svg": 85595,
	"./BH.svg": 22428,
	"./BI.svg": 11901,
	"./BJ.svg": 57726,
	"./BL.svg": 35568,
	"./BM.svg": 71105,
	"./BN.svg": 77970,
	"./BO.svg": 92611,
	"./BQ.svg": 37413,
	"./BR.svg": 14982,
	"./BS.svg": 29367,
	"./BT.svg": 40184,
	"./BV.svg": 59962,
	"./BW.svg": 90923,
	"./BY.svg": 62989,
	"./BZ.svg": 14638,
	"./CA.svg": 73094,
	"./CC.svg": 7620,
	"./CD.svg": 75211,
	"./CF.svg": 42505,
	"./CG.svg": 17144,
	"./CH.svg": 27359,
	"./CI.svg": 12718,
	"./CK.svg": 64684,
	"./CL.svg": 70899,
	"./CM.svg": 83522,
	"./CN.svg": 24273,
	"./CO.svg": 26240,
	"./CP.svg": 14215,
	"./CR.svg": 87637,
	"./CU.svg": 74890,
	"./CV.svg": 24185,
	"./CW.svg": 11816,
	"./CX.svg": 43791,
	"./CY.svg": 7390,
	"./CZ.svg": 70013,
	"./DE.svg": 53219,
	"./DG.svg": 1921,
	"./DJ.svg": 96180,
	"./DK.svg": 57461,
	"./DM.svg": 27803,
	"./DO.svg": 11833,
	"./DZ.svg": 84772,
	"./EA.svg": 92600,
	"./EC.svg": 28730,
	"./EE.svg": 38660,
	"./EG.svg": 67398,
	"./EH.svg": 65553,
	"./ENGLAND.svg": 17877,
	"./ER.svg": 38011,
	"./ES.svg": 61290,
	"./ET.svg": 84501,
	"./EU.svg": 11892,
	"./FI.svg": 6137,
	"./FJ.svg": 61738,
	"./FK.svg": 79579,
	"./FM.svg": 72149,
	"./FO.svg": 18023,
	"./FR.svg": 98658,
	"./GA.svg": 96738,
	"./GB.svg": 77137,
	"./GD.svg": 49599,
	"./GE.svg": 95310,
	"./GF.svg": 6029,
	"./GG.svg": 70572,
	"./GH.svg": 85547,
	"./GI.svg": 80282,
	"./GL.svg": 41783,
	"./GM.svg": 78982,
	"./GN.svg": 15205,
	"./GP.svg": 5635,
	"./GQ.svg": 72594,
	"./GR.svg": 54337,
	"./GS.svg": 39536,
	"./GT.svg": 57007,
	"./GU.svg": 94430,
	"./GW.svg": 77980,
	"./GY.svg": 38250,
	"./HK.svg": 34369,
	"./HM.svg": 88015,
	"./HN.svg": 8988,
	"./HR.svg": 26744,
	"./HT.svg": 59014,
	"./HU.svg": 46551,
	"./IC.svg": 59654,
	"./ID.svg": 86537,
	"./IE.svg": 27384,
	"./IL.svg": 57809,
	"./IM.svg": 896,
	"./IN.svg": 7987,
	"./IO.svg": 77410,
	"./IQ.svg": 29268,
	"./IR.svg": 17127,
	"./IS.svg": 61238,
	"./IT.svg": 44921,
	"./JE.svg": 15105,
	"./JM.svg": 14521,
	"./JO.svg": 17691,
	"./JP.svg": 55020,
	"./KE.svg": 31746,
	"./KG.svg": 23488,
	"./KH.svg": 98967,
	"./KI.svg": 11430,
	"./KM.svg": 15290,
	"./KN.svg": 14025,
	"./KP.svg": 40431,
	"./KR.svg": 15677,
	"./KW.svg": 74544,
	"./KY.svg": 63990,
	"./KZ.svg": 5237,
	"./LA.svg": 72119,
	"./LB.svg": 28996,
	"./LC.svg": 80165,
	"./LI.svg": 85823,
	"./LK.svg": 5741,
	"./LR.svg": 2228,
	"./LS.svg": 74837,
	"./LT.svg": 51626,
	"./LU.svg": 28347,
	"./LV.svg": 77608,
	"./LY.svg": 44207,
	"./MA.svg": 68992,
	"./MC.svg": 26274,
	"./MD.svg": 54797,
	"./ME.svg": 7436,
	"./MF.svg": 86463,
	"./MG.svg": 55470,
	"./MH.svg": 85257,
	"./MK.svg": 40442,
	"./ML.svg": 47621,
	"./MM.svg": 50372,
	"./MN.svg": 4823,
	"./MO.svg": 15846,
	"./MP.svg": 67521,
	"./MQ.svg": 76400,
	"./MR.svg": 65795,
	"./MS.svg": 78834,
	"./MT.svg": 12765,
	"./MU.svg": 84220,
	"./MV.svg": 86543,
	"./MW.svg": 50142,
	"./MX.svg": 66937,
	"./MY.svg": 54568,
	"./MZ.svg": 86459,
	"./NA.svg": 96201,
	"./NC.svg": 75883,
	"./NE.svg": 5541,
	"./NF.svg": 69318,
	"./NG.svg": 32119,
	"./NI.svg": 67473,
	"./NL.svg": 60908,
	"./NO.svg": 39935,
	"./NP.svg": 89192,
	"./NR.svg": 28586,
	"./NU.svg": 213,
	"./NZ.svg": 62930,
	"./OM.svg": 32350,
	"./PA.svg": 11939,
	"./PE.svg": 20783,
	"./PF.svg": 41756,
	"./PG.svg": 31229,
	"./PH.svg": 28202,
	"./PK.svg": 19577,
	"./PL.svg": 63190,
	"./PM.svg": 27015,
	"./PN.svg": 78804,
	"./PR.svg": 96512,
	"./PS.svg": 32465,
	"./PT.svg": 33966,
	"./PW.svg": 82317,
	"./PY.svg": 10251,
	"./QA.svg": 84012,
	"./RE.svg": 72777,
	"./RO.svg": 77875,
	"./RS.svg": 87015,
	"./RU.svg": 31161,
	"./RW.svg": 47131,
	"./SA.svg": 95062,
	"./SB.svg": 8021,
	"./SC.svg": 63092,
	"./SCOTLAND.svg": 22334,
	"./SD.svg": 94715,
	"./SE.svg": 52746,
	"./SG.svg": 13352,
	"./SH.svg": 71503,
	"./SI.svg": 8926,
	"./SJ.svg": 21021,
	"./SK.svg": 92476,
	"./SL.svg": 20131,
	"./SM.svg": 87090,
	"./SN.svg": 68833,
	"./SO.svg": 54032,
	"./SR.svg": 29701,
	"./SS.svg": 51684,
	"./ST.svg": 43,
	"./SV.svg": 20361,
	"./SX.svg": 47743,
	"./SY.svg": 9806,
	"./SZ.svg": 20525,
	"./TA.svg": 68287,
	"./TC.svg": 76301,
	"./TD.svg": 17986,
	"./TF.svg": 9728,
	"./TG.svg": 72529,
	"./TH.svg": 97670,
	"./TJ.svg": 42084,
	"./TK.svg": 96805,
	"./TL.svg": 1530,
	"./TM.svg": 4235,
	"./TN.svg": 65400,
	"./TO.svg": 265,
	"./TR.svg": 47644,
	"./TT.svg": 67986,
	"./TV.svg": 60784,
	"./TW.svg": 73025,
	"./TZ.svg": 65844,
	"./UA.svg": 65128,
	"./UG.svg": 97814,
	"./UM.svg": 95228,
	"./UN.svg": 74255,
	"./US.svg": 32762,
	"./UY.svg": 57312,
	"./UZ.svg": 28211,
	"./VA.svg": 53265,
	"./VC.svg": 99891,
	"./VE.svg": 24685,
	"./VG.svg": 56351,
	"./VI.svg": 71497,
	"./VN.svg": 2086,
	"./VU.svg": 99005,
	"./WALES.svg": 48482,
	"./WF.svg": 46589,
	"./WS.svg": 2816,
	"./XK.svg": 33937,
	"./YE.svg": 69064,
	"./YT.svg": 99753,
	"./ZA.svg": 25069,
	"./ZM.svg": 6505,
	"./ZW.svg": 54691,
	"./inter.svg": 79052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22256;